import omit from 'lodash/omit';
export const actions = {
    set_width(value) {
        this.width = value;
        return this;
    },
    set_height(value) {
        this.height = value;
        return this;
    },
    set_format(value) {
        this.format = value;
        return this;
    },
    set_file_url(value) {
        this.file_url = value;
        return this;
    },
};
export const videoFileFactory = (callback) => {
    const videoFile = Object.create(actions);
    callback === null || callback === void 0 ? void 0 : callback(videoFile);
    return omit(videoFile, Object.keys(actions));
};
